import Splide from '../../Helper/NeosSplide';

export default class PersonSlider {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.person-slider.splide'), (el) => {
            new PersonSlider(el);
        });
    }

    constructor(el) {
        if (!el) {
            return;
        }

        this.el = el;
        this.inNeosBackend = window.name === 'neos-content-main';

        this.slider = new Splide(this.el, {
            type: 'slide',
            rewind: false,
            drag: !this.inNeosBackend,
            pagination: false,
            perMove: 1,
            gap: '2rem',
            autoWidth: true,
            focus: 0,
            trimSpace: 'move',
            omitEnd: true,
        });

        // Fade each edge only while more slides exist that way
        this.slider.on('mounted move moved drag dragged scroll scrolled updated resized', () => this.updateEdgeFades());

        this.slider.mount();
    }

    updateEdgeFades() {
        const isAtStart = this.slider.index <= 0;
        const isAtEnd = this.slider.index >= this.slider.Components.Controller.getEnd();

        this.el.toggleAttribute('data-fade-start', !isAtStart);
        this.el.toggleAttribute('data-fade-end', !isAtEnd);
    }
}
